/**
 * Cashflow-Wasserfall (C2.4b) — Recharts stacked BarChart mit transparentem
 * Sockel-Segment (`base`) + sichtbarem Balken (`bar`). Feste Maße statt
 * ResponsiveContainer: deterministisch in jsdom (kein ResizeObserver), kein
 * 0-Groessen-Warning → Test-Output bleibt sauber.
 */
import { Bar, BarChart, Cell, Tooltip, XAxis, YAxis } from 'recharts';
import type { WaterfallStep } from '../lib/waterfall';
import { formatEur } from '../lib/format';

const FILL: Record<WaterfallStep['kind'], string> = {
  start: '#3b82f6',
  increase: '#16a34a',
  decrease: '#dc2626',
  total: '#6366f1',
};

export function CashflowWaterfall({ steps }: { steps: WaterfallStep[] }) {
  return (
    <div data-testid="cashflow-waterfall" className="overflow-x-auto">
      <BarChart
        width={560}
        height={240}
        data={steps}
        margin={{ top: 8, right: 8, bottom: 8, left: 8 }}
      >
        <XAxis dataKey="label" fontSize={11} />
        <YAxis fontSize={11} width={64} tickFormatter={(v) => formatEur(v as number)} />
        <Tooltip formatter={(_v, _n, p) => formatEur((p?.payload as WaterfallStep)?.value)} />
        <Bar dataKey="base" stackId="wf" fill="transparent" isAnimationActive={false} />
        <Bar dataKey="bar" stackId="wf" isAnimationActive={false}>
          {steps.map((s, i) => (
            <Cell key={`${s.label}-${i}`} fill={FILL[s.kind]} />
          ))}
        </Bar>
      </BarChart>
    </div>
  );
}
